<template>
	<transition 
			appear
			:appear-active-class="$_admnBnrLyt_stylePageLayoutAnimation()">
		<v-row	class="customVRow" 
				align="start"
				justify="center"
				no-gutters>
			<v-col cols="12" sm ="11" md="10">
				<template v-for="(operationTypeVal, operationTypeKey) in operationTypes_">
					<v-sheet :key="operationTypeKey" class="customVSheet mb-6 px-3">
						<v-row class="pt-2" justify="center">
							<v-col cols="auto">
								<span class="text-h6" v-text="operationTypeVal" />
							</v-col>
						</v-row>
						<v-row>
							<template v-for="(contentVals, contentKey) in sortObject(contents, 'order')">
								<template v-if="contentVals.operationType == operationTypeKey">
									<v-col :key="contentKey" cols="12" sm="6" md="4">
										<v-banner
												class="customVBanner"

												:color="$_admnBnrLyt_styleBannerColor"
												:dark="$_admnBnrLyt_styleBannerDark"
												:elevation="$_admnBnrLyt_styleBannerElevation"
												:icon-color="$_admnBnrLyt_styleBannerIconColor"
												:light="$_admnBnrLyt_styleBannerLight"
												:outlined="$_admnBnrLyt_styleBannerOutlined"
												:rounded="$_admnBnrLyt_styleBannerRounded"
												:shaped="$_admnBnrLyt_styleBannerShaped"
												:single-line="$_admnBnrLyt_styleBannerSingleLine"
												:tile="$_admnBnrLyt_styleBannerTile"
												
												:icon="$_admnBnrLyt_styleContentIcon(contentVals)">
											<v-row>
												<v-col>
													<template v-if="contentVals.title">
														<v-row>
															<v-col>
																<span	class="subtitle-1"
																		v-html="$_admnBnrLyt_langContentTitle(contentVals)" />
															</v-col>
														</v-row>
														<v-divider/>
													</template>
													<template v-if="!isFalse($_admnBnrLyt_langContentText(contentVals))">
														<v-row>
															<v-col>
																<span	class="caption markdown"
																		v-html="marked($_admnBnrLyt_langContentText(contentVals))" />
															</v-col>
														</v-row>
													</template>
												</v-col>
												<template v-if="isObject(contentVals.actionButtons)">
													<v-col cols="auto">
														<v-row class="row_" align="center">
															<v-col>
																<v-row>
																	<v-col class="py-2">
																		<v-btn	class="customVBtn"
																				:block="$_admnBnrLyt_styleActionButtonBlock"
																				:color="$_admnBnrLyt_styleActionButtonColor"
																				:dark="$_admnBnrLyt_styleActionButtonDark"
																				:depressed="$_admnBnrLyt_styleActionButtonDepressed"
																				:elevation="$_admnBnrLyt_styleActionButtonElevation"
																				:large="$_admnBnrLyt_styleActionButtonLarge"
																				:light="$_admnBnrLyt_styleActionButtonLight"
																				:outlined="$_admnBnrLyt_styleActionButtonOutlined"
																				:rounded="$_admnBnrLyt_styleActionButtonRounded"
																				:small="$_admnBnrLyt_styleActionButtonSmall"
																				:text="$_admnBnrLyt_styleActionButtonFlat"
																				@click="$_admnBnrLyt_open(contentVals, contentKey)">
																			Open
																		</v-btn>
																	</v-col>
																</v-row>
																<template v-for="(actionButtonVals, actionButtonKey) in sortObject(contentVals.actionButtons, 'order')">
																	<v-row :key="actionButtonKey">
																		<v-col class="py-2">
																			<v-btn	class="customVBtn"
																					:block="$_admnBnrLyt_styleActionButtonBlock"
																					:color="$_admnBnrLyt_styleActionButtonColor"
																					:dark="$_admnBnrLyt_styleActionButtonDark"
																					:depressed="$_admnBnrLyt_styleActionButtonDepressed"
																					:elevation="$_admnBnrLyt_styleActionButtonElevation"
																					:large="$_admnBnrLyt_styleActionButtonLarge"
																					:light="$_admnBnrLyt_styleActionButtonLight"
																					:outlined="$_admnBnrLyt_styleActionButtonOutlined"
																					:rounded="$_admnBnrLyt_styleActionButtonRounded"
																					:small="$_admnBnrLyt_styleActionButtonSmall"
																					:text="$_admnBnrLyt_styleActionButtonFlat"
																					@click="openLink(actionButtonVals.link)"
																					v-text="$_admnBnrLyt_langActionButtonTitle(actionButtonVals)" />
																		</v-col>
																	</v-row>
																</template>
															</v-col>
														</v-row>
													</v-col>
												</template>
											</v-row>
										</v-banner>
									</v-col>
								</template>
							</template>
						</v-row>
					</v-sheet>
				</template>
			</v-col>
		</v-row>
	</transition>
</template>

<script>
	export default {
		name: 'AdminBannerLayout',
		props: {
			contents: Object,
			inits: Object
		},
		data() {
			return {
				operationTypes_: {
					user: 'User',
					group: 'Group',
					point: 'Point',
					training: 'Training',
					notification: 'Notification'
				}
			}
		},
		computed: {
			// state
			$_admnBnrLyt_stateAppIsMobileScreen() {
				const self_ = this;
				return self_.getAppState('isMobileScreen')
			},
			// lang 
			// (content)
			$_admnBnrLyt_langContentTitle() {
				const self_ = this;
				return contentVals => {
					const contentVal_ = contentVals.title;
					if(self_.isFalse(contentVal_)) { return null }
					return self_.getLangsVal(contentVal_)
				}
			},
			$_admnBnrLyt_langContentText() {
				const self_ = this;
				return contentVals => {
					const contentVal_ = contentVals.text;
					if(self_.isFalse(contentVal_)) { return null }
					return self_.getLangsVal(contentVal_)
				}
			},
			// (content - action button)
			$_admnBnrLyt_langActionButtonTitle() {
				const self_ = this;
				return actionButtonVals => {
					const actionButtonVal_ = actionButtonVals.title;
					if(self_.isFalse(actionButtonVal_)) { return null }
					return self_.getLangsVal(actionButtonVal_)
				}
			},
			// style
			$_admnBnrLyt_stylePageLayout() {
				const self_ = this;
				return () => {
					if(self_.isEmpty(self_.inits)) { return null }
					return self_.getInitsStyleVal(self_.inits, 'pageLayout')
				}
			},
			$_admnBnrLyt_stylePageLayoutAnimation() {
				const self_ = this;
				return () => {
					const layout_ = self_.$_admnBnrLyt_stylePageLayout()
					if(self_.isFalse(layout_)) { return null }
					return self_.getStylesVal(layout_.animation)
				}
			},
			$_admnBnrLyt_styleBanner() {
				const self_ = this;
				return self_.getInitsStyleVal(self_.inits, 'banner')
			},
			$_admnBnrLyt_styleBannerColor() {
				const self_ = this;
				const banner_ = self_.$_admnBnrLyt_styleBanner;
				if(self_.isFalse(banner_)) { return null }
				return self_.getStylesVal(banner_.color)
			},
			$_admnBnrLyt_styleBannerDark() {
				const self_ = this;
				const banner_ = self_.$_admnBnrLyt_styleBanner;
				if(self_.isFalse(banner_)) { return null }
				return self_.getStylesVal(banner_.dark)
			},
			$_admnBnrLyt_styleBannerElevation() {
				const self_ = this;
				const banner_ = self_.$_admnBnrLyt_styleBanner;
				if(self_.isFalse(banner_)) { return null }
				return self_.getStylesVal(banner_.elevation)
			},
			$_admnBnrLyt_styleBannerFlat() {
				const self_ = this;
				const banner_ = self_.$_admnBnrLyt_styleBanner;
				if(self_.isFalse(banner_)) { return null }
				return self_.getStylesVal(banner_.flat)
			},
			$_admnBnrLyt_styleBannerHover() {
				const self_ = this;
				const banner_ = self_.$_admnBnrLyt_styleBanner;
				if(self_.isFalse(banner_)) { return null }
				return self_.getStylesVal(banner_.hover)
			},
			$_admnBnrLyt_styleBannerIconColor() {
				const self_ = this;
				const banner_ = self_.$_admnBnrLyt_styleBanner;
				if(self_.isFalse(banner_)) { return null }
				return self_.getStylesVal(banner_.iconColor)
			},
			$_admnBnrLyt_styleBannerLight() {
				const self_ = this;
				const banner_ = self_.$_admnBnrLyt_styleBanner;
				if(self_.isFalse(banner_)) { return null }
				return self_.getStylesVal(banner_.light)
			},
			$_admnBnrLyt_styleBannerOutlined() {
				const self_ = this;
				const banner_ = self_.$_admnBnrLyt_styleBanner;
				if(self_.isFalse(banner_)) { return null }
				return self_.getStylesVal(banner_.outlined)
			},
			$_admnBnrLyt_styleBannerRounded() {
				const self_ = this;
				const banner_ = self_.$_admnBnrLyt_styleBanner;
				if(self_.isFalse(banner_)) { return null }
				return self_.getStylesVal(banner_.rounded)
			},
			$_admnBnrLyt_styleBannerShaped() {
				const self_ = this;
				const banner_ = self_.$_admnBnrLyt_styleBanner;
				if(self_.isFalse(banner_)) { return null }
				return self_.getStylesVal(banner_.shaped)
			},
			$_admnBnrLyt_styleBannerSingleLine() {
				const self_ = this;
				const banner_ = self_.$_admnBnrLyt_styleBanner;
				if(self_.isFalse(banner_)) { return null }
				return self_.getStylesVal(banner_.singleLine)
			},
			$_admnBnrLyt_styleBannerTile() {
				const self_ = this;
				const banner_ = self_.$_admnBnrLyt_styleBanner;
				if(self_.isFalse(banner_)) { return null }
				return self_.getStylesVal(banner_.tile)
			},
			$_admnBnrLyt_styleActionButton() {
				const self_ = this;
				return self_.getInitsStyleVal(self_.inits, 'actionButton')
			},
			$_admnBnrLyt_styleActionButtonBlock() {
				const self_ = this;
				const actionButton_ = self_.$_admnBnrLyt_styleActionButton;
				if(self_.isFalse(actionButton_)) { return null }
				return self_.getStylesVal(actionButton_.block)
			},
			$_admnBnrLyt_styleActionButtonColor() {
				const self_ = this;
				const actionButton_ =self_.$_admnBnrLyt_styleActionButton;
				if(self_.isFalse(actionButton_)) { return null }
				return self_.getStylesVal(actionButton_.color)
			},
			$_admnBnrLyt_styleActionButtonDark() {
				const self_ = this;
				const actionButton_ = self_.$_admnBnrLyt_styleActionButton;
				if(self_.isFalse(actionButton_)) { return null }
				return self_.getStylesVal(actionButton_.dark)
			},
			$_admnBnrLyt_styleActionButtonDepressed() {
				const self_ = this;
				const actionButton_ = self_.$_admnBnrLyt_styleActionButton;
				if(self_.isFalse(actionButton_)) { return null }
				return self_.getStylesVal(actionButton_.depressed)
			},
			$_admnBnrLyt_styleActionButtonElevation() {
				const self_ = this;
				const actionButton_ = self_.$_admnBnrLyt_styleActionButton;
				if(self_.isFalse(actionButton_)) { return null }
				return self_.getStylesVal(actionButton_.elevation)
			},
			$_admnBnrLyt_styleActionButtonFlat() {
				const self_ = this;
				const actionButton_ = self_.$_admnBnrLyt_styleActionButton;
				if(self_.isFalse(actionButton_)) { return null }
				return self_.getStylesVal(actionButton_.flat)
			},
			$_admnBnrLyt_styleActionButtonLarge() {
				const self_ = this;
				const actionButton_ = self_.$_admnBnrLyt_styleActionButton;
				if(self_.isFalse(actionButton_)) { return null }
				return self_.getStylesVal(actionButton_.large)
			},
			$_admnBnrLyt_styleActionButtonLight() {
				const self_ = this;
				const actionButton_ = self_.$_admnBnrLyt_styleActionButton;
				if(self_.isFalse(actionButton_)) { return null }
				return self_.getStylesVal(actionButton_.light)
			},
			$_admnBnrLyt_styleActionButtonOutlined() {
				const self_ = this;
				const actionButton_ = self_.$_admnBnrLyt_styleActionButton;
				if(self_.isFalse(actionButton_)) { return null }
				return self_.getStylesVal(actionButton_.outlined)
			},
			$_admnBnrLyt_styleActionButtonRounded() {
				const self_ = this;
				const actionButton_ = self_.$_admnBnrLyt_styleActionButton;
				if(self_.isFalse(actionButton_)) { return null }
				return self_.getStylesVal(actionButton_.rounded)
			},
			$_admnBnrLyt_styleActionButtonSmall() {
				const self_ = this;
				const actionButton_ = self_.$_admnBnrLyt_styleActionButton;
				if(self_.isFalse(actionButton_)) { return null }
				return self_.getStylesVal(actionButton_.small)
			},
			// (content)
			$_admnBnrLyt_styleContentIcon() {
				const self_ = this;
				return contentVals => {
					const contentVal_ = contentVals.icon;
					if(self_.isFalse(contentVal_)) { return null }
					return self_.getStylesVal(contentVal_)
				}
			}
		},
		methods: {
			$_admnBnrLyt_open(contentVals, contentKey) {
				const self_ = this;
				const router_ = self_.$router;

				const operationType_ = contentVals.operationType;
				const operationName_ = contentKey;

				router_.push({
					name: 'adminOperationName',
					params: {
						operationType: operationType_,
						operationName: operationName_
					}
				})
			}
		}
	}
</script>

<style scoped>
	.cardActions_ {
		padding-bottom: 16px;
	}
	.row_ {
		height: 100%;
	}
</style>
